import axios from 'axios';
import { CREATE_OFFICER_ATTENDANCE_MUTATION, DELETE_ATTENDANCE_MUTATION, UPDATE_ATTENDANCE_MUTATION, UPDATE_WORKSHOP_MUTATION, } from '../../../../graphql/mutations/workshop/attendance.mutations';
import { GET_ATTENDANCE_LIST_QUERY, GET_OFFICER_LOOKUP_QUERY, GET_TRAINING_CLEARANCES_QUERY, GET_WORKSHOP_RECORDS_QUERY, } from '../../../../graphql/queries/workshop/attendance.queries';
import { GET_OFFICER_BY_USERNAME_QUERY } from '~/graphql/queries/officers.queries';
export const createOfficerAttendance = async (officer, data) => {
    const response = await axios.request({
        data: {
            query: CREATE_OFFICER_ATTENDANCE_MUTATION,
            variables: {
                inputData: {
                    county: sessionStorage.getItem('county'),
                    createdBy: sessionStorage.getItem('officerId'),
                    officerId: officer,
                    hoursType: data.type,
                    hoursLogged: data.hours,
                    workshopName: data.name,
                    startDate: data.startDate,
                    endDate: data.endDate,
                    comments: data.comments,
                },
            },
        },
    });
    const { data: { createOfficerAttendance: { __typename }, }, } = response.data;
    if (__typename != 'AttendanceData') {
        throw new Error(__typename);
    }
    return {
        response,
    };
};
export const deleteAttendance = async (attendanceId) => {
    const response = await axios.request({
        data: {
            query: DELETE_ATTENDANCE_MUTATION,
            variables: {
                attendanceId: attendanceId,
            },
        },
    });
    const { data: { deleteAttendance: { __typename }, }, } = response.data;
    if (__typename != 'AttendanceData') {
        throw new Error(__typename);
    }
    return {
        response,
    };
};
export const getAttendanceList = async (workshopId) => {
    const mutation = GET_ATTENDANCE_LIST_QUERY;
    const response = await axios.request({
        data: {
            query: mutation,
            variables: {
                workshopId: workshopId,
            },
        },
    });
    const { data: { getAttendanceList: attendances }, } = response.data;
    if (attendances.__typename !== 'AttendanceList') {
        throw new Error(attendances.__typename);
    }
    return attendances;
};
export const getOfficerAttendances = async (officerId) => {
    const response = await axios.request({
        data: {
            query: GET_WORKSHOP_RECORDS_QUERY,
            variables: {
                county: sessionStorage.getItem('county'),
                officerId: officerId,
                sort: 'DESC',
            },
        },
    });
    const { data: { getWorkshopRecords: { records, __typename }, }, } = response.data;
    if (__typename != 'RecordSummary') {
        throw new Error(__typename);
    }
    return records;
};
export const getOfficerInfo = async (username) => {
    const query = GET_OFFICER_BY_USERNAME_QUERY;
    const variables = {
        county: sessionStorage.getItem('county'),
        username,
    };
    const response = await axios.request({
        data: {
            query,
            variables,
        },
    });
    const { data: { getOfficerByUsername: officerData }, } = response.data;
    if (officerData.__typename != 'OfficerData') {
        throw new Error(officerData.__typename);
    }
    return { ...officerData };
};
export const getTrainingClearances = async () => {
    const response = await axios.request({
        data: {
            query: GET_TRAINING_CLEARANCES_QUERY,
            variables: {
                county: sessionStorage.getItem('county'),
                officerId: sessionStorage.getItem('officerId'),
            },
        },
    });
    const { data: { getTrainingClearances: { __typename, editClearance }, }, } = response.data;
    if (__typename != 'ClearanceData') {
        throw new Error(__typename);
    }
    return {
        editClearance,
    };
};
export const queryOfficers = async (search, size, after) => {
    const response = await axios.request({
        data: {
            query: GET_OFFICER_LOOKUP_QUERY,
            variables: {
                county: sessionStorage.getItem('county'),
                queryString: search,
                count: size + 1,
                after: after,
            },
        },
    });
    const { data: { getOfficerLookup: { officers, count, __typename }, }, } = response.data;
    if (__typename != 'OfficerLookupData') {
        throw new Error(__typename);
    }
    let nextAfter = '';
    if (officers.length > size) {
        officers.pop();
        nextAfter = officers[officers.length - 1].id;
    }
    for (const index in officers) {
        officers[index].selected = false;
    }
    return { officers: officers, after: nextAfter, count };
};
export const updateAttendance = async (attendanceId, startDate, endDate, hoursLogged, comments) => {
    const response = await axios.request({
        data: {
            query: UPDATE_ATTENDANCE_MUTATION,
            variables: {
                attendanceId: attendanceId,
                inputData: {
                    startDate,
                    endDate,
                    hoursLogged,
                    comments,
                },
            },
        },
    });
    const { data: { updateAttendance: { __typename }, }, } = response.data;
    if (__typename != 'AttendanceData') {
        throw new Error(__typename);
    }
    return {
        response,
    };
};
export const updateWorkshop = async (workshopId, workshopName) => {
    const mutation = UPDATE_WORKSHOP_MUTATION;
    const response = await axios.request({
        data: {
            query: mutation,
            variables: {
                inputData: {
                    name: workshopName,
                },
                workshopId: workshopId,
            },
        },
    });
    const { data: { updateWorkshop: { __typename }, }, } = response.data;
    if (__typename !== 'WorkshopData') {
        throw new Error(__typename);
    }
    return {
        response,
    };
};
